import {ModuleWithProviders, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import {Environment} from "@snelstart/util";
import { BOKKZ_BASE_URL, BOKKZ_SERVICE_URL, BokkzClient } from './services/api.bokkz.services';
import {SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {SharedUiButtonModule} from "@snelstart/ui-button";
import {SharedUiDialogModule} from "@snelstart/ui-dialog";
import {SharedUiOffCanvasModule} from "@snelstart/ui-off-canvas";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {WorkflowComponent} from "./workflow/workflow.component";
import {SharedUiIconModule} from "@snelstart/ui-icon";
import {SharedUiTableModule} from "@snelstart/ui-table";
import {SharedUiTooltipModule} from "@snelstart/ui-tooltip";
import {SharedUiTabModule} from "@snelstart/ui-tab";
import {SharedUiAlertModule} from "@snelstart/ui-alert";
import {
  API_ADMINISTRATION_MANAGEMENT_BASE_URL,
  API_RELATION_MANAGEMENT_BASE_URL,
  SST_BASE_URL,
  SST_WEBBASE_URL
} from './services/rekenclient.api';

@NgModule({
  imports: [
    CommonModule,
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDialogModule,
    SharedUiOffCanvasModule,
    SharedUiDetailsModule,
    SharedUiIconModule,
    SharedUiTableModule,
    SharedUiTooltipModule,
    SharedUiTabModule,
    SharedUiAlertModule,
    WorkflowComponent,
  ],
  providers:[BokkzClient],
  declarations: [],
  exports: [
    WorkflowComponent,
  ],
})
export class DomainLogicModule {
  static forRoot(type: Environment): ModuleWithProviders<DomainLogicModule> {
    return {
      ngModule: DomainLogicModule,
      providers: [
        {
          provide: BOKKZ_BASE_URL, useFactory: () => {
            switch (type) {
              case Environment.Local:
                return "http://localhost:8080";
                // return "https://test.leukermakkelijker.nl";
              case Environment.Development:
                return "https://test.leukermakkelijker.nl";
              case Environment.Test:
                return "https://test.leukermakkelijker.nl";
              case Environment.Production:
                return "https://prod.leukermakkelijker.nl";
              default:
                return "https://test.leukermakkelijker.nl";
            }
          }
        },
          {
              provide: BOKKZ_SERVICE_URL, useFactory: () => {
                  switch (type) {
                      case Environment.Local:
                      return "https://test.leukermakkelijker.nl";
                      case Environment.Development:
                          return "https://test.leukermakkelijker.nl";
                      case Environment.Test:
                          return "https://test.leukermakkelijker.nl";
                      case Environment.Production:
                          return "https://prod.leukermakkelijker.nl";
                      default:
                          return "https://test.leukermakkelijker.nl";
                  }
              }
          },
        {
          provide: SST_BASE_URL, useFactory: () => {
            switch (type) {
              case Environment.Local:
              return "https://api-dev.snelstart.nl";
              case Environment.Development:
                return "https://api-dev.snelstart.nl";
              case Environment.Test:
                return "https://api-tst.snelstart.nl";
              case Environment.Production:
                return "https://api.snelstart.nl";
              default:
                return "https://api.snelstart.nl";
            }
          }
        },
        {
          provide: SST_WEBBASE_URL, useFactory: () => {
            switch (type) {
              case Environment.Local:
                return "https://webapi-tst.snelstart.nl";
              case Environment.Development:
                return "https://webapi-tst.snelstart.nl";
              case Environment.Test:
                return "https://webapi-tst.snelstart.nl";
              case Environment.Production:
                return "https://webapi.snelstart.nl";
              default:
                return "https://webapi.snelstart.nl";
            }
          }
        },
        {
          provide: API_RELATION_MANAGEMENT_BASE_URL, useFactory: () => {
            switch (type) {
              case Environment.Local:
              case Environment.Development:
                return 'https://api-dev.snelstart.nl/product/relation-management';
              case Environment.Test:
                return 'https://api-tst.snelstart.nl/product/relation-management';
              default: return 'https://api.snelstart.nl/product/relation-management';
            }
          }
        },
        {
          provide: API_ADMINISTRATION_MANAGEMENT_BASE_URL,
          useFactory: () => {
            switch (type) {
              case Environment.Local:
              case Environment.Development:
                return 'https://api-dev.snelstart.nl/operations/administration-management';
              case Environment.Test:
                return 'https://api-tst.snelstart.nl/operations/administration-management';
              default: return 'https://api.snelstart.nl/operations/administration-management';
            }
          }
        },
      ]
    };
  }
}
